const ErrorMessage = type => {
    if (type === "required")
        return "پر کردن این فیلد الزامیست";
    else if (type === "format" || type === "pattern" || type === "minLength" || type === "maxLength")
        return "فرمت وارد شده صحیح نمی باشد";

    return type;
}

export default ErrorMessage;